import ReactPlayer from "react-player";
import { useState, useRef, useEffect } from "react";
import { formatTime } from "../../../tools/format";
import Controls from "./Controls";
import "./customVideoPlayer.css";
import { toast } from "react-toastify";

let count = 0;
const CustomVideoPlayer = ({ src }) => {
  const videoContainerRef = useRef(null);
  const videoPlayerRef = useRef(null);
  const controlRef = useRef(null);
  const rates = [0.5, 1.0, 1.25, 1.5, 1.75, 2.0, 2.5, 3.0, 4.0];
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [manualFullScreen, setManualFullScreen] = useState(false);
  const phoneNumber = localStorage.getItem("phonenumber");

  const [videoState, setVideoState] = useState({
    playing: false,
    muted: false,
    volume: 0.5,
    playbackRate: 1.0,
    played: 0,
    seeking: false,
    buffer: false,
  });

  //Destructuring the properties from the videoState
  const { playing, muted, volume, playbackRate, played, seeking, buffer } =
    videoState;

  const currentTime = videoPlayerRef.current
    ? videoPlayerRef.current.getCurrentTime()
    : "00:00";
  const duration = videoPlayerRef.current
    ? videoPlayerRef.current.getDuration()
    : "00:00";

  const formatCurrentTime = formatTime(currentTime);
  const formatDuration = formatTime(duration);

  //handling hotKeys
  useEffect(() => {

    const handleKeyDown = (e) => {
      if(e.code === "Space"){
        e.preventDefault();
        playPauseHandler();
      }else if(e.code === "ArrowRight"){
        e.preventDefault();
        handleFastFoward();
      }else if(e.code === "ArrowLeft"){
        e.preventDefault();
        rewindHandler();
      }
    }

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown" , handleKeyDown)
    }
  },[])

  const playPauseHandler = (e) => {
    //plays and pause the video (toggling)
    setVideoState((prevState) => ({...prevState , playing: !prevState.playing}));
  };

  const rewindHandler = () => {
    //Rewinds the video player reducing 5
    videoPlayerRef.current.seekTo(videoPlayerRef.current.getCurrentTime() - 10);
  };

  const handleFastFoward = () => {
    //FastFowards the video player by adding 10
    videoPlayerRef.current.seekTo(videoPlayerRef.current.getCurrentTime() + 10);
  };

  //console.log("========", (controlRef.current.style.visibility = "false"));
  const progressHandler = (state) => {
    if (count > 1) {
      console.log("close");
      controlRef.current.style.visibility = "hidden"; // toggling player control container
    } else if (controlRef.current.style.visibility === "visible") {
      count += 1;
    }

    if (!seeking) {
      setVideoState({ ...videoState, ...state });
    }
  };

  const seekHandler = (e) => {
    setVideoState({ ...videoState, played: parseFloat(e.target.value / 100) });
    videoPlayerRef.current.seekTo(parseFloat(e.target.value / 100));
  };

  const seekMouseUpHandler = (e) => {
    if (!isFinite(e.target.value)) {
      console.error("Invalid seek value:", value);
      return;
    }

    setVideoState({ ...videoState, seeking: false });
    videoPlayerRef.current.seekTo(e.target.value / 100);
  };

  const volumeChangeHandler = (e) => {
    const newVolume = parseFloat(e.target.value) / 100;

    setVideoState({
      ...videoState,
      volume: newVolume,
      muted: Number(newVolume) === 0 ? true : false, // volume === 0 then muted
    });
  };

  const volumeSeekUpHandler = (e) => {
    const newVolume = parseFloat(e.target.value) / 100;

    setVideoState({
      ...videoState,
      volume: newVolume,
      muted: newVolume === 0 ? true : false,
    });
  };

  const muteHandler = () => {
    //Mutes the video player
    setVideoState({ ...videoState, muted: !videoState.muted });
  };

  const onSeekMouseDownHandler = (e) => {
    setVideoState({ ...videoState, seeking: true });
  };

  const mouseMoveHandler = () => {
    controlRef.current.style.visibility = "visible";
    count = 0;
  };

  const bufferStartHandler = () => {
    console.log("Bufering.......");
    setVideoState({ ...videoState, buffer: true });
  };

  const bufferEndHandler = () => {
    console.log("buffering stoped ,,,,,,play");
    setVideoState({ ...videoState, buffer: false });
  };

  const toggleFullScreen = () => {
    if (isFullscreen) {
      exitFullScreen();
    } else {
      goFullScreen();
    }
  };

  const goFullScreen = () => {
    const videoContainer = videoContainerRef.current;
    if (videoContainer.requestFullscreen) {
      videoContainer.requestFullscreen();
    } else if (videoContainer.msRequestFullscreen) {
      videoContainer.msRequestFullscreen();
    } else if (videoContainer.mozRequestFullScreen) {
      videoContainer.mozRequestFullScreen();
    } else if (videoContainer.webkitRequestFullscreen) {
      videoContainer.webkitRequestFullscreen();
    } else {
      setManualFullScreen(true);
    }
    setIsFullscreen(true);
  };

  const exitFullScreen = () => {
    if (isFullscreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else {
        setManualFullScreen(false);
      }
      setIsFullscreen(false);
    }
  };

  const handlePlaybackRateChange = (e) => {
    // console.log("e is ", e);
    // console.log("e is target ", e.target.value);
    const newRate = parseFloat(e.target.value);
    setVideoState({ ...videoState, playbackRate: newRate });
  };

  return (
    <div
      ref={videoContainerRef}
      id="vid-cont"
      className={
        manualFullScreen ? "video_container fullScreen" : "video_container"
      }
    >
      <div className="player__wrapper" onMouseMove={mouseMoveHandler}>
        <ReactPlayer
          playsinline
          ref={videoPlayerRef}
          className="my-video-player"
          url={src}
          width="100%"
          height="100%"
          playing={playing}
          volume={volume}
          playbackRate={playbackRate}
          muted={muted}
          onProgress={progressHandler}
          onBuffer={bufferStartHandler}
          onBufferEnd={bufferEndHandler}
        />

        {phoneNumber && <p className="video-waterMark">{phoneNumber}</p>}

        <Controls
          controlRef={controlRef}
          onPlayPause={playPauseHandler}
          playing={playing}
          onRewind={rewindHandler}
          onForward={handleFastFoward}
          played={played}
          onSeek={seekHandler}
          onSeekMouseUp={seekMouseUpHandler}
          volume={volume}
          onVolumeChangeHandler={volumeChangeHandler}
          onVolumeSeekUp={volumeSeekUpHandler}
          mute={muted}
          onMute={muteHandler}
          playRate={playbackRate}
          duration={formatDuration}
          currentTime={formatCurrentTime}
          onMouseSeekDown={onSeekMouseDownHandler}
          toggleFullScreen={toggleFullScreen}
          buffer={buffer}
          rates={rates}
          onPlayBackRateChange={handlePlaybackRateChange}
        />
      </div>
    </div>
  );
};

export default CustomVideoPlayer;
